import { DeliveryDate } from '@delivery/const';
import { StateUtils } from '@spartacus/core';
import { DELIVERY_DATE } from '../delivery-state';

export const LOAD_DELIVERY_DATE = '[Delivery] Load Delivery Date';
export const LOAD_DELIVERY_DATE_FAIL = '[Delivery] Load Delivery Date Fail';
export const LOAD_DELIVERY_DATE_SUCCESS = '[Delivery] Load Delivery Date Success';
export const LOAD_DELIVERY_DATE_RESET = '[Delivery] Load Delivery Date Reset';

export class LoadDeliveryDate extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_DELIVERY_DATE;

  constructor() {
    super(DELIVERY_DATE);
  }
}

export class LoadDeliveryDateFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_DELIVERY_DATE_FAIL;

  constructor(public payload: any) {
    super(DELIVERY_DATE, payload);
  }
}

export class LoadDeliveryDateSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_DELIVERY_DATE_SUCCESS;

  constructor(public payload: DeliveryDate) {
    super(DELIVERY_DATE);
  }
}

export class ResetDeliveryDate extends StateUtils.LoaderResetAction {
  readonly type = LOAD_DELIVERY_DATE_RESET;

  constructor() {
    super(DELIVERY_DATE);
  }
}

export type DeliveryDateActions = LoadDeliveryDate | LoadDeliveryDateSuccess | LoadDeliveryDateFail | ResetDeliveryDate;
